$(document).ready(function() {
    $(".block__mntn-casestudies-wrapper").slick({
        arrows: false,
        draggable: true,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 2,
        responsive: [
             {
                breakpoint: 1024,
                settings: {
                slidesToShow: 1
             }
            },
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
            },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
            }
        ]
    }); 
});